<template>
  <div class="page-container">
    <el-row>
      <el-col :span="4" :xs="24" class="container-left">
        <div class="container-title">
          <span>组织架构</span>
        </div>
        <div class="head-container">
          <el-tree
            :data="orgTree"
            :props="defaultProps"
            :expand-on-click-node="false"
            ref="tree"
            node-key="id"
            :default-expand-all="isShowNode"
            @node-click="handleNodeClick"
            :highlight-current="true"
          >
            <span class="custom-tree-node tree-list" slot-scope="{ data }">
              <span>{{ data.name }}</span>
              <span class="tree-status" v-show="data.status == 0">无效</span>
            </span>
          </el-tree>
        </div>
      </el-col>
      <el-col :span="20" :xs="24" class="container-right">
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button
              v-if="orgStatus == 1"
              class="add-button"
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="handleAdd"
              >新增职务</el-button
            >
            <el-checkbox
              style="padding: 0 0 15px 10px"
              v-model="isChecked"
              fill="#20b2aa"
              @change="showSonList"
              >只展示当前部门直属职务</el-checkbox
            >
          </el-col>
        </el-row>
        <el-table :data="dataList" style="width: 100%" v-loading="loading">
          <el-table-column
            prop="code"
            label="职务编号"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="职务名称"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="organizationName"
            label="所属机构"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="sort"
            label="排序"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            min-width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                :active-value="1"
                :inactive-value="0"
                @change="statusChange(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateUserName"
            label="最后操作人"
            align="center"
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="updateTime"
            label="最后操作时间"
            align="center"
            min-width="170"
          >
          </el-table-column>
          <el-table-column
            prop="age"
            label="操作"
            align="center"
            min-width="150"
            class="handle-btn"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="edit(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next, sizes, total, jumper"
          :page-sizes="[10, 15, 20]"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="700px"
      @close="handleClose" 
      
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="职务编码" prop="code">
          <el-input v-model="form.code" placeholder="输入职务编码"></el-input>
        </el-form-item>
        <el-form-item label="职务名称" prop="name">
          <el-input v-model="form.name" placeholder="输入职务名称"></el-input>
        </el-form-item>
        <el-form-item label="所属机构" prop="organizationId">
          <el-col :span="8">
            <treeselect
              :options="orgTree"
              :value="form.organizationId"
              :normalizer="normalizer"
              :show-count="true"
              :clearable="false"
              @select="orgTreeSelected"
            />
          </el-col>
        </el-form-item>
        <el-form-item label="所属角色" prop="roleId">
          <el-select v-model="form.roleId" @change="getRoleId">
            <el-option
              :label="item.roleName"
              :value="item.roleId"
              v-for="item in roleList"
              :key="item.roleId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序号" prop="sort">
          <el-input v-model="form.sort" maxlength="5" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="form.remark" maxlength="100" show-word-limit="true"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAddOrEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryPositionPageList,
  queryOrganizationByCurrentUser,
  saveOrEditPosition,
  updateOrgStatus,
  getSystemRolesList,
  updatePositionStatus,
} from "@/common/api.js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: { Treeselect },
  props: {},
  data() {
    return {
      dialogVisible: false,
      isShowNode: true,
      loading: false,
      orgStatus: 1,
      rules: [],
      orgTree: [],
      roleList: [],
      dataList: [],
      defaultProps: {
        children: "systemOrganizations",
        label: "name",
      },
      normalizer(node) {
        if (
          node.systemOrganizations == null ||
          node.systemOrganizations == "null"
        ) {
          delete node.systemOrganizations;
        }
        return {
          id: node.id,
          label: node.name,
          children: node.systemOrganizations,
        };
      },
      total: 0,
      pageSize: 10,
      currpage: 1,
      // 弹出层标题
      title: "",
      //表单验证
      rules: {
        code: [
          { required: true,validator: this.testCode, trigger: "blur" },
        ],
        name: [{ required: true, validator: this.testName,trigger: "blur" }],
        roleId: [
          { required: true, message: "请选择所属角色", trigger: "blur" },
        ],
      },
      // 所属机构id
      parentId: "",
      //新增、编辑
      form: {
        id: null,
        name: "",
        organizationId: "",
        code: "",
        roleId: null,
        sort: null,
        remark: "",
      },
      isChecked: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    getRoleId() {},
    // 组织架构树
    getOrganizationTree(pid) {
      queryOrganizationByCurrentUser().then((res) => {
        console.log("res :>> ", res);
        if (res.errorCode == 200 && res.data) {
          this.orgTree = [];
          this.orgTree.push(res.data);
          if (pid) {
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(pid);
            });
          } else {
            var id = res.data.id;
            this.queryPositionPageList(id);
            this.parentId = id;
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(id);
            });
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 选择组织架构节点
    handleNodeClick(data) {
      var id = data.id;
      this.parentId = id;
      this.orgStatus = data.status;
      this.queryPositionPageList(id);
    },
    // 职位列表
    queryPositionPageList(id) {
      this.loading = true;
      var byParent = "";
      if (this.isChecked) {
        byParent = "yse";
      } else {
        byParent = "";
      }
      var params = {
        pageSize: this.pageSize,
        pagenum: this.currpage,
        data: {
          organizationId: id,
          byParent: byParent,
        },
      };
      queryPositionPageList(params).then((res) => {
        console.log("res :>> ", res);
        this.loading = false;
        if (res.errorCode == 200) {
          this.dataList = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 部门直属职位列表
    showSonList() {
      this.queryPositionPageList(this.parentId);
    },
    //选择所属机构
    orgTreeSelected(node) {
      this.form.organizationId = node.id;
    },
    //获取角色列表
    getSystemRolesList() {
      var data = {
        roleType: "systemRole",
      };
      getSystemRolesList(data).then((res) => {
        if (res.errorCode == 200) {
          this.roleList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 新增职务
    handleAdd() {
      this.reset();
      this.dialogVisible = true;
      this.title = "新增职务";
      this.form.organizationId = this.parentId;
      console.log(this.form);
    },
    // 编辑职务
    edit(row) {
      console.log(row);
      this.reset();
      this.dialogVisible = true;
      this.title = "编辑职务";
      this.form = {
        id: row.id,
        name: row.name,
        organizationId: row.organizationId,
        code: row.code,
        roleId: row.roleId,
        sort: row.sort,
        remark: row.remark,
      };
      console.log(this.form);
    },
    // 新增或编辑保存
    saveAddOrEdit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          saveOrEditPosition(this.form).then((res) => {
            if (res.errorCode == 200) {
              this.queryPositionPageList(this.parentId);
              this.dialogVisible = false;
              this.$message({
                type: "success",
                message: "保存成功",
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    //变更状态
    statusChange(row) {
      var department = row.name;
      var mess = "";
      let text = "";
      if (row.status == 1) {
        text = "有效";
      } else if (row.status == 0) {
        text = "无效";
        mess = "设置为无效后，该机构将不在其他业务中显示";
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h(
            "h3",
            null,
            '是否将 "' + department + '" 的状态变为 "' + text + '" ?',
            "警告"
          ),
          h("h4", { style: "color:#a0a0a0" }, mess),
        ]),
        showCancelButton: true,
        closeOnClickModal:false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            var params = {
              id: row.id,
              status: row.status,
            };
            updatePositionStatus(params).then((res) => {
              if (res.errorCode == 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message.error(res.msg);
                if (row.status == 1) {
                  row.status = 0;
                } else if (row.status == 0) {
                  row.status = 1;
                }
              }
            });
          } else {
            done();
            if (row.status == 1) {
              row.status = 0;
            } else if (row.status == 0) {
              row.status = 1;
            }
            console.log(row.status);
          }
        },
      })
        .then((action) => {
          console.log("是确定吗");
        })
        .catch(() => {
          console.log("是取消吗");
        });
    },
    // 表单数据清空
    reset() {
      this.form = {
        id: null,
        name: "",
        organizationId: "",
        code: "",
        roleId: null,
        sort: null,
        remark: "",
      };
    },
    //弹框关闭 重置form
    handleClose() {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    },
    //选页
    handleCurrentChange(cpage) {
      this.currpage = cpage;
      var id = this.parentId;
      this.queryPositionPageList(id);
    },
    handleSizeChange(psize) {
      this.pageSize = psize;
      var id = this.parentId;
      this.queryPositionPageList(id);
    },
    isExpand() {
      this.isShowNode = !this.isShowNode;
      console.log(this.isShowNode);
    },
    testCode(rule, value, callback) {
      if (value) {
        if (value.length > 20) {
          callback(new Error("最多输入20个字符"));
        }
        var str = /^[a-z\d]*$/i;
        if (!value.match(str)) {
          callback(new Error("仅支持输入数字、字母"));
        }
        callback();
      } else {
        callback(new Error("请输入机构编号"));
      }
    },
    testName(rule, value, callback) {
      if (value) {
        if (value.length > 20) {
          callback(new Error("最多输入20个字符"));
        }
        var str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\ \/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/;
        if (value.match(str)) {
          callback(new Error("不能输入特殊字符"));
        }
        callback();
      } else {
        callback(new Error("请输入职务名称"));
      }
    },
  },
  created() {},
  mounted() {
    this.getOrganizationTree(this.parentId);
    this.getSystemRolesList();
  },
};
</script>
<style lang="less" scoped>
.page-container {
  height: 100%;
  .el-row {
    height: 100%;
  }
  margin-left: -20px;
  .container-left {
    padding: 0 10px;
    background-color: #fff;
    height: 100%;
    width: 17%;
    .container-title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #eee;
      .el-icon-arrow-down {
        margin-left: 15px;
        font-weight: 800;
      }
      .expand-btn {
        img {
          width: 15px;
          height: 15px;
          vertical-align: middle;
          margin-left: 5px;
          transform: rotate(0deg);
          transition: transform 0.5s;
        }
        .active {
          transform: rotate(180deg);
          transition: transform 0.5s;
        }
      }
    }
  }
  .container-right {
    padding: 12px 10px;
    border-radius: 6px;
    background-color: #fff;
    margin-top: 10px;
    margin-left: 12px;
    width: calc(83% - 12px);
    //   margin-bottom: 10px;
    //   box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .add-button {
      margin-bottom: 10px;
      margin-right: 20px;
    }
  }
  .tree-list {
    font-size: 14px;
    .tree-status {
      font-size: 12px;
      background-color: #f0f0f0;
      padding: 2px 3px;
      color: red;
    }
  }
  /deep/.el-tree-node:focus > .el-tree-node__content {
    background-color: #e4e4e4;
  }
  /deep/.el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: #e4e4e4;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/baseInfoManage/positionManage.vue